import Entity from './entity'

export default class Article extends Entity<string>{
    content: string;
    title: string;
    contentForm: number;
    pdfFiles: any;
    topicTwoId: number;
    externalType: number = 2;
    topicTwoList: any;
    topicOneId: number;
    topicOne: any;
    attachmentFiles: any;
    author: string;
    issued: string;
    sortNo: string;
    isMemberSee: number;
    creationTime: string;
    isRecommend: boolean;
    categoryId: number;
    allCategorys:string;
    gradeType: number;
    categoryList: any;
    isAudit: boolean;
    pdfFilePath: string;
    testPaperId: string;
    description: string;
    isExport: boolean;
    isAllShow: boolean;
    chapterTypeAndContent: any;
    titlePicture: any;
    isRollingShow: boolean;
    titlePictureId: string;
    titePictureImg: string;
    questionDetails: any;
    clickVolume: number;
}